module.exports = __webpack_public_path__ + "assets/img/photo-3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/photo-3.jpg
// module id = 1991
// module chunks = 0